/**
 * 과목 관리 데모 페이지 (Mock 버전)
 */

import React from 'react';
import { BookOpenIcon } from '@heroicons/react/24/outline';
import DemoNavigation from '../components/DemoNavigation';

const mockSubjects = [
  { id: '1', name: '수학', students: 15, avg_score: 88 },
  { id: '2', name: '영어', students: 18, avg_score: 92 },
  { id: '3', name: '국어', students: 12, avg_score: 78 },
  { id: '4', name: '과학', students: 14, avg_score: 85 },
];

const DemoSubjectManagementPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-blue-600 text-white py-3 px-4 text-center">
        <p className="text-sm">📢 이것은 데모 페이지입니다. 모든 데이터는 가상 데이터이며, 데모 시연을 위해 주기적으로 업데이트되어 조금씩 변동될 수 있습니다.</p>
      </div>
      <DemoNavigation currentTitle="과목 관리 (데모)" currentIcon={BookOpenIcon} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow">
          <div className="px-6 py-4 border-b">
            <h2 className="text-2xl font-bold">과목 관리</h2>
          </div>
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {mockSubjects.map((subject) => (
                <div key={subject.id} className="border rounded-lg p-6 hover:border-blue-500 transition-colors">
                  <h3 className="text-2xl font-bold mb-4">{subject.name}</h3>
                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <span className="text-gray-600">수강 인원</span>
                      <span className="font-semibold">{subject.students}명</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-gray-600">평균 성적</span>
                      <span className={`font-semibold ${
                        subject.avg_score >= 90 ? 'text-green-600' : subject.avg_score >= 80 ? 'text-blue-600' : 'text-orange-600'
                      }`}>
                        {subject.avg_score}점
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-6 text-center text-gray-500 text-sm">
              📢 데모 모드에서는 과목 추가 및 수정이 불가능합니다.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoSubjectManagementPage;
